import React from "react";
import PropTypes from "prop-types";
import { Button, ModalFooter, Spinner } from "reactstrap";
import { formatCurrency } from "common/number-formatter";

const propTypes = {
  cancelFlowData: PropTypes.shape({
    retention_coupon_id: PropTypes.string.isRequired,
    retention_coupon: PropTypes.number.isRequired
  }).isRequired,
  yearlySavings: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  onClaim: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
};

const RetentionCouponStep = ({
  cancelFlowData,
  yearlySavings,
  isLoading,
  error = null,
  onClaim,
  onSkip
}) => {
  const retentionCouponPct = cancelFlowData?.retention_coupon || 0;

  return (
    <div>
      <p className="text-center font-weight-bold mb-1">We really value top customers like you.</p>
      <p className="text-center text-muted mb-3">
        Here&apos;s an amazing offer to keep your campaign running.
      </p>

      <div className="text-center mb-3">
        {retentionCouponPct > 0 && (
          <p className="h5 text-success mb-1">An Additional {retentionCouponPct}% Savings</p>
        )}
        <p className="h4 font-weight-bold mb-1">Save {formatCurrency(yearlySavings)}</p>
        <p className="text-muted">
          You&apos;ll save {formatCurrency(yearlySavings)} over the next year, starting with your
          next renewal.
        </p>
      </div>

      {error && (
        <div className="notifications danger mb-3">
          <div className="notifications__error-message">{error}</div>
        </div>
      )}

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onSkip} disabled={isLoading}>
          I don&apos;t want my discount
        </Button>
        <Button color="primary" className="btn-sharp" onClick={onClaim} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner color="light" size="sm" /> Processing...
            </>
          ) : (
            "Claim My Discount"
          )}
        </Button>
      </ModalFooter>
    </div>
  );
};

RetentionCouponStep.propTypes = propTypes;

export default RetentionCouponStep;
